import React from 'react';
import { FadeIn, Section } from './ui';
import { CheckCircle2, XCircle } from 'lucide-react';
export function QualificationSection() {
  const isForYou = ['Sos docente de matemática de secundaria en Argentina', 'Querés dejar de improvisar y tener un sistema claro', 'Tenés alumnos con discapacidad y no sabés cómo adaptarles las evaluaciones', 'Querés que tus notas sean irrefutables ante padres y directivos', 'Estás cansado de preparar materiales que te llevan horas', 'Querés recuperar tu tiempo los fines de semana'];
  const notForYou = ['Buscás recetas mágicas sin implementar nada', 'No estás dispuesto a cambiar ningún hábito de tu práctica docente', 'Querés un PDF de actividades genéricas para fotocopiar'];
  return <Section variant="dark" className="!max-w-none" data-id="element-224">
      <div className="max-w-[900px] mx-auto" data-id="element-225">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-226">
          {/* Left Column - Is For You */}
          <FadeIn data-id="element-227">
            <div className="bg-green-50/50 p-6 md:p-8 rounded-3xl border border-green-200 h-full" data-id="element-228">
              <h2 className="text-2xl md:text-3xl font-black text-gray-900 mb-6" data-id="element-229">
                Matemática 360 es para vos si:
              </h2>
              <ul className="space-y-4" data-id="element-230">
                {isForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-231">
                    <CheckCircle2 className="text-green-600 shrink-0 mt-0.5" size={22} data-id="element-232" />
                    <span className="text-gray-700 text-base" data-id="element-233">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Right Column - Not For You */}
          <FadeIn delay={0.2} data-id="element-234">
            <div className="bg-red-50/50 p-6 md:p-8 rounded-3xl border border-red-200 h-full" data-id="element-235">
              <h2 className="text-2xl md:text-3xl font-black text-gray-900 mb-6" data-id="element-236">
                No es para vos si:
              </h2>
              <ul className="space-y-4" data-id="element-237">
                {notForYou.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-238">
                    <XCircle className="text-red-500 shrink-0 mt-0.5" size={22} data-id="element-239" />
                    <span className="text-gray-600 text-base" data-id="element-240">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </Section>;
}